import React, { Component } from 'react';

import classes from './SocialIcons.module.scss';
import { getFileName } from 'helpers/FileCaching';
import FacebookIcon from './FacebookIcon/FacebookIcon'
import TwitterIcon from './TwitterIcon/TwitterIcon'

const socialIcons = require.context('images/components/Articles/Article/SocialIcons', true, /.*\.(gif|png|jpe?g|svg)$/i);

class SocialIcons extends Component {

    constructor(props){
        super(props);
    }

    render(){
        return (
            <div className={classes.socialIcons}>
           
                <TwitterIcon twitterDescription={this.props.content['description-twitter']} twitterDescriptionHashtag={this.props.content['description-twitter-hashtags']} url={this.props.url}/>
                <FacebookIcon title={this.props.content['title']} facebookDescription={this.props.content.og_meta['description-facebook']}  url={this.props.url} />
                
            </div>
        );
    }
}

export default SocialIcons;